import { KeyboardArrowDown } from "@mui/icons-material";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import AutoCompleteDropdown from "../../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import CustomListBox from "../../../provider-management/components/fields/CustomListBox";
import FieldLabel from "../../../provider-management/components/provider-details/FieldLabel";
import ProviderTypeChip from "../../../provider-management/components/provider-details/ProviderTypeChip";
import { STYLES } from "../../../provider-management/utils/customStyles";
import { PROVIDER_DETAIL_STYLES } from "../../styles";

import { MAX_PROVIDER_TYPES } from "./primarySectionUtils";

export default function ProviderTypesField({
  helperText,
  isEditing,
  loading,
  onChange,
  onLoadMore,
  onSearchChange,
  options,
  selectedOptions,
  showMore,
}) {
  return (
    <div className="flex flex-col gap-2">
      <FieldLabel value="Provider Types" />
      {isEditing ? (
        <AutoCompleteDropdown
          multiple
          size="small"
          data={options}
          initValue={selectedOptions}
          placeholder="Search provider types"
          loading={loading}
          getOptionLabel={(option) => option?.label || ""}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionDisabled={(option, selected) =>
            selectedOptions.length >= MAX_PROVIDER_TYPES &&
            !selected.some((value) => value.id === option.id)
          }
          renderTags={(value, getTagProps) =>
            value.map((option, index) => {
              const tagProps = getTagProps({ index });
              return (
                <div
                  key={option.id}
                  {...tagProps}
                  className="flex items-center gap-2 px-2"
                  style={PROVIDER_DETAIL_STYLES.providerTypeChip}
                >
                  <Typography
                    className="text-[12px] font-normal"
                    sx={PROVIDER_DETAIL_STYLES.providerTypeChipText}
                  >
                    {option.label}
                  </Typography>
                  <span
                    onClick={tagProps.onDelete}
                    className="text-[14px]"
                    style={PROVIDER_DETAIL_STYLES.providerTypeChipText}
                  >
                    ×
                  </span>
                </div>
              );
            })
          }
          onValueChange={onChange}
          onInputChange={(_, value) => onSearchChange(value)}
          ListboxComponent={CustomListBox}
          ListboxProps={{ showMore, setShowMore: onLoadMore, sx: { maxHeight: 200, overflow: "auto" } }}
          dropdownSx={STYLES.selectMenuPaper}
          popupIcon={<KeyboardArrowDown sx={PROVIDER_DETAIL_STYLES.dropdownArrowIcon} />}
          textFieldSx={{
            ...STYLES.textField,
            "& .MuiAutocomplete-inputRoot": { display: "flex", flexWrap: "wrap", gap: "6px", padding: "6px" },
          }}
          helperText={helperText}
        />
      ) : selectedOptions.length ? (
        <div className="flex flex-wrap gap-2">
          {selectedOptions.map((item) => (
            <ProviderTypeChip key={item.id} label={item.label} />
          ))}
        </div>
      ) : (
        <Typography className="text-[14px]" sx={PROVIDER_DETAIL_STYLES.emptyValue}>
          Not available
        </Typography>
      )}
    </div>
  );
}

ProviderTypesField.propTypes = {
  helperText: PropTypes.string.isRequired,
  isEditing: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  showMore: PropTypes.bool.isRequired,
};
